export const generateId = () => Math.random().toString(36).substr(2, 9);

export interface InvoiceItem {
    id: string;
    name: string;
    unit: string;
    quantity: number;
    price: number;
    vat: number; // Percentage, e.g., 21
}

export interface CompanyDetails {
    name: string;
    address: string;
    vatCode: string;
    registrationCode: string;
    bankAccount: string;
    bankName: string;
    swift: string;
    email: string;
    phone: string;
    logoUrl?: string;
}

export interface ClientDetails {
    name: string;
    address: string;
    vatCode: string;
    registrationCode: string;
    email: string;
    phone: string;
}

export interface InvoiceMeta {
    series: string;
    number: string;
    date: string; // ISO date string
    dueDate: string; // ISO date string
}

export interface Invoice {
    company: CompanyDetails;
    client: ClientDetails;
    meta: InvoiceMeta;
    items: InvoiceItem[];
}

export interface InvoiceTotals {
    subtotal: number;
    vatAmount: number;
    total: number;
}

export const calculateItemTotal = (item: InvoiceItem): number => {
    return item.quantity * item.price;
};

export const calculateItemVat = (item: InvoiceItem): number => {
    return (calculateItemTotal(item) * item.vat) / 100;
};

export const calculateInvoiceTotals = (items: InvoiceItem[]): InvoiceTotals => {
    const subtotal = items.reduce((sum, item) => sum + calculateItemTotal(item), 0);
    const vatAmount = items.reduce((sum, item) => sum + calculateItemVat(item), 0);
    const total = subtotal + vatAmount;

    return {
        subtotal,
        vatAmount,
        total,
    };
};

export const formatCurrency = (amount: number, currency: string = 'EUR'): string => {
    return new Intl.NumberFormat('lt-LT', {
        style: 'currency',
        currency: currency,
    }).format(amount);
};
